import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-adminlistados-eventos',
  templateUrl: './adminlistados-eventos.component.html',
  styleUrls: ['./adminlistados-eventos.component.scss']
})
export class AdminlistadosEventosComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/adminlistados-eventos/adminlistados-eventos.component.ts